<ion-badge class="badge" [color]="color">
  {{ text }}
</ion-badge>
